import { fromJS } from 'immutable'
import {
  ACCOUNTING_BILLING_EDIT_REQUEST,
  ACCOUNTING_BILLING_EDIT_SUCCESS,
  ACCOUNTING_BILLING_EDIT_FAILURE,
  ACCOUNTING_BILLING_EDIT_RESET,
} from '../../actions/accounting-dashboard/types'

const init = fromJS({
  isFetching: false,
  isAuthenticated: localStorage.getItem('access_token') !== null,
  redirect: false,
})

export default (state = init, action) => {
  switch (action.type) {
    case ACCOUNTING_BILLING_EDIT_REQUEST:
      return state
        .set('isFetching', true)
    case ACCOUNTING_BILLING_EDIT_SUCCESS:
      return state
        .set('isFetching', false)
        .set('type', 'success')
        .set('status', 'Updated Successfully')
        .set('message', 'The data had successfully been updated')
        .set('updatedAccountantBilling', fromJS(action.payload.updatedAccountantBilling))
    case ACCOUNTING_BILLING_EDIT_FAILURE:
      if (action.payload.status === 401) {
        return state
          .set('redirect', true)
      }
      return state
        .set('isFetching', false)
        .set('type', 'error')
        .set('status', 'Error')
        .set('updatedAccountantBilling', fromJS(action.payload.message))
        .set('message', fromJS(action.payload.response.message))
    case ACCOUNTING_BILLING_EDIT_RESET:
      return state
        .set('isFetching', false)
        .set('type', null)
        .set('status', null)
        .set('updatedAccountantBilling', null)
        .set('message', null)
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/accounting-dashboard/billing-update-reducer.js